import { useMediaQuery, useTheme } from '@material-ui/core';
import { useLottie } from 'lottie-react';
import React, { useEffect, useRef } from 'react';
import { l1 } from './lottie/Experimenting';
import { l2 } from './lottie/Transitioning';
import { l3 } from './lottie/Optimising';
import { l4 } from './lottie/Transforming';
import { relative } from 'path';

export const Picture: React.FC<{ summary: number; id: number }> = ({
  summary,
  id,
}) => {
  const elRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (elRef.current) {
      const svg = elRef.current.querySelector('svg');
      if (!svg) {
        return;
      }
      svg.setAttribute('viewBox', '200 200 400 400');
    }
  }, []);

  return (
    <div
      style={{
        height: matches ? 190 : 200,
        width: matches ? 190 : 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          filter: id === summary ? undefined : 'opacity(0.5)',
        }}
      >
        <img
          style={{
            filter: id === summary ? undefined : 'grayscale(1)',
          }}
          src={process.env.PUBLIC_URL + '/r' + id + '.svg'}
          alt=""
        />
      </div>
    </div>
  );
};

export const BarPicture: React.FC<{ summary: number; id: number }> = ({
  summary,
  id,
}) => {
  const elRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div>
      <img
        style={{
          visibility: id === summary ? 'visible' : 'hidden',
          left: 194,
          position: 'relative',
          top: -18,
          zIndex: 15,
        }}
        src={process.env.PUBLIC_URL + ('/r' + id + 'circle.svg')}
        alt=""
      />
      <img
        style={{
          visibility: id === summary ? 'visible' : 'hidden',
          left: 184,
          zIndex: 5,
          position: 'relative',
          top: -31,
        }}
        src={process.env.PUBLIC_URL + ('/r' + id + 'arrow.svg')}
        alt=""
      />
    </div>
  );
};
